import { ReadonlyURLSearchParams } from 'next/navigation';

export const getFreeCancelation = (searchParams: ReadonlyURLSearchParams) => !!searchParams.get('freeCancelation');
